<template>
    <div class="col">
        <h2 class="title">{{titles.main}}</h2>
        <form action="#" class="form">
            <div class="field">
                <div class="field-name-wrap">
                    <label class="field-name">{{titles.emails}}</label>
                    <button type="button" class="btn success no-bg save" :disabled="!emailVal.length"  @click="editEmailClick">{{emailBtnText}}</button>
                </div>
                <input type="text" class="form-control" :placeholder="titles.emails" v-model="emailVal" :disabled="!editEmail">
            </div>
            <div class="field">
                <div class="field-name-wrap">
                    <label class="field-name">{{titles.subject}}</label>
                    <button type="button" class="btn success no-bg save" :disabled="!subjectVal.length" @click="editSubjectClick">{{subjectBtnText}}</button>
                </div>
                <input type="text" class="form-control" :placeholder="titles.subject" v-model="subjectVal" :disabled="!editSubject">
            </div>
            <div class="field">
                <div class="field-name-wrap">
                    <label class="field-name">{{titles.content}}</label>
                    <button type="button" class="btn success no-bg save" :disabled="!contentVal.length"  @click="editContentClick">{{contentBtnText}}</button>
                </div>
                <textarea class="form-control" :placeholder="titles.content" v-model="contentVal" :disabled="!editContent" ref="ta"></textarea>
            </div>
        </form>
    </div>

</template>

<script>
import {mapActions} from "vuex"

export default {
    name: 'settings-column',
    props: {
        titles: Object,
        emails: String,
        subject: { type: String, default: ''},
        content: String
    },

    watch: {
        emails: function(newVal) {
            this.emailVal = newVal
        },
        subject: function(newVal) {
            this.subjectVal = newVal
        },
        content: function(newVal) {
            this.contentVal = newVal
        }
    },

    data() {
        return {
            emailVal: this.emails,
            contentVal: this.content,
            subjectVal: this.subject,
            editEmail: false,
            editContent: false,
            editSubject: false,
        }
    },

    computed: {
        emailEmpty() {
            return !!this.emailVal.length
        },
        emailBtnText() {
            return this.editEmail ? 'Save' : 'Edit';
        },
        contentBtnText() {
            return this.editContent ? 'Save' : 'Edit';
        },
        subjectBtnText() {
            return this.editSubject ? 'Save' : 'Edit';
        },
    },

    methods: {
        ...mapActions('settings', [
            'saveSettings'
        ]),
        editEmailClick() {
            if (this.editEmail) {
                let result = {};
                result[this.titles.settings + '_emails'] = this.emailVal;
                this.saveSettings(result);
            }
            this.editEmail = !this.editEmail
        },
        editSubjectClick() {
            if (this.editSubject) {
                let result = {};
                result[this.titles.settings + '_email_subject'] = this.subjectVal;
                this.saveSettings(result);
            }
            this.editSubject = !this.editSubject
        },
        editContentClick() {
            if (this.editContent) {
                let result = {};
                result[this.titles.settings + '_email_content'] = this.contentVal;
                this.saveSettings(result);
            }
            this.editContent = !this.editContent
        },
        insertShortcode(value) {
            if (!this.editContent) return;

            let tArea = this.$refs.ta;

            let startPos = tArea.selectionStart;
            let endPos = tArea.selectionEnd;

            this.contentVal = this.contentVal.substring(0, startPos) + value + this.contentVal.substring(endPos, this.contentVal.length);
        }

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .three-cols-box .col .field:nth-child(2) {
        margin-bottom: 25px;
    }
</style>
